import React, { Component } from "react";
import { Page } from "pages/page";
import Input from "ui/input";
import Api from "api";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./index.module.scss";

type Props = object;

interface State {
	name: string;
	url: string;
}

class Submit extends Component<Props, State> {
	public constructor (props: Props) {
		super(props);
		this.state = {
			name: "",
			url: "",
		};
	}
	public async submit (): Promise<void> {
		const id = await Api.submitGame(this.state.name, this.state.url);
		const url = `/game/${ id }`;
		window.location.assign(url);
	}
	public render (): JSX.Element {
		return <div className={ styles.card }>
			<span className={ styles.warning }>
				Do not submit leaked versions of fangames which are in active development, nor cracked paid fangames!
			</span>
			<form
				className={ styles.form }
				onSubmit={ e => {
					e.preventDefault();
					this.submit().catch(console.error);
				} }
			>
				<div className={ styles.field }>
					<label>Game name</label>
					<Input
						value={ this.state.name }
						onChange={ name => this.setState({ name }) }
						placeholder="I wanna be the..."
						onEnter={ () => this.submit().catch(console.error) }
					/>
				</div>
				<div className={ styles.field }>
					<label>Download link</label>
					<Input
						value={ this.state.url }
						onChange={ url => this.setState({ url }) }
						placeholder="https://..."
						onEnter={ () => this.submit().catch(console.error) }
					/>
				</div>
				<button type="submit" className={ styles.submitButton }>
					<FontAwesomeIcon icon={ faPaperPlane } className={ styles.icon } />
					Submit
				</button>
			</form>
		</div>;
	}
}

const page = new Page({
	name: "Submit",
	content: <Submit />,
	icon: faPaperPlane,
});

export default page;
